import axios from 'axios'
import router from "./router";

function getCookie(name: string): string|null {
  const nameLenPlus = (name.length + 1);
  return document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
      return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
      return decodeURIComponent(cookie.substring(nameLenPlus));
    })[0] || null;
}

const instance = axios.create()

instance.interceptors.request.use((config) => {
  config.headers.Authorization = "bearer "+ getCookie("accessToken");
  return config;
}, (error) => {
  return Promise.reject(error);
});

instance.interceptors.response.use(
  response => {
    return response
  },
  async (error) => {
    console.log('error.request',error.request)
    let status = error.request.status
    if(status === 403) {
      if(error.request.message.indexOf('jwt') != -1) {
        router.push({path: "/dangnhap"})
      }
      router.push({path: "/403"})
    }
    return Promise.reject(error);
    // if(status === 404) {
    //   router.push({path: '/404'})
    // }
    // if(status === 500) {
    //   router.push({path: '/500'})
    // }
  }
);;

export default instance